import { render, staticRenderFns } from "./SxswEventsKeywordsModule.vue?vue&type=template&id=a81e68f4&"
import script from "./SxswEventsKeywordsModule.vue?vue&type=script&lang=js&"
export * from "./SxswEventsKeywordsModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports